import { dispatcher, store } from '@store';
import { API_V2_URL } from '@utils';

export default async function loadControlsLock() {
  await fetch(`${API_V2_URL}/controls-lock/locked`, {
    headers: {
      authorization: `Bearer ${store.getState().user.keycloak?.token}`,
    },
  })
    .then((res) => res.json())
    .then((lockedControllers: string[]) => {
      if (Array.isArray(lockedControllers)) {
        store.dispatch(
          dispatcher('SET_CONTROLS_LOCK', {
            lockedControllers,
          }),
        );
      }
    })
    .catch((err) => {
      console.error(err);
    });

  const state = store.getState();
  const client = state.mqtt.clientMQTT;

  if (!client) {
    return;
  }

  const TOPIC = 'site/controls-lock';
  client.subscribe(TOPIC);

  client.on('message', (topic, message) => {
    if (topic === TOPIC) {
      const lockedControllers = JSON.parse(
        message.toString(),
      ).lockedControllers;

      if (!lockedControllers) {
        return;
      }

      store.dispatch(
        dispatcher('SET_CONTROLS_LOCK', {
          lockedControllers,
        }),
      );
    }
  });
}
